import api from './index'

export const authApi = {
  login(data) {
    return api.post('/auth/login/', data)
  },
  logout() {
    return api.post('/auth/logout/')
  },
  getMe() {
    return api.get('/auth/me/')
  },
}

